import type { LinkProps } from 'react-router';

import { isChangeUrl } from '@change-corgi/core/navigation';

export function getLinkRel({ to, rel }: Pick<LinkProps, 'to' | 'rel'>): string | undefined {
	if (rel) return rel;
	return typeof to === 'string' && !isChangeUrl(to) ? 'nofollow noopener noreferrer' : undefined;
}
